import * as React from 'react';
import Menu from '@mui/material/Menu';
import { Formik, Form } from 'formik';
import { IconButton, TextField, Typography, Button, Stack, Box, MenuItem } from '@mui/material';
import Iconify from '../Iconify';

const Filter = ({ toggleFilter, applyFilters }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div>
        <Box style={{ display: 'flex', justifyContent: 'end' }}>
          <IconButton onClick={handleClick}>
            <Iconify icon="ic:round-filter-list" />
            <Typography variant="h6"> Filter</Typography>
          </IconButton>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <Formik
              initialValues={{
                userId: '',
                fullname: '',
                phone: '',
                email: '',
                paymentMethod: '',
                clubId: '',
                startDate: '',
                endDate: '',
              }}
              onSubmit={async (values) => {
                applyFilters(values);
              }}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                <Form style={{ padding: '10px' }}>
                  <Stack direction="column">
                    <Stack spacing={1} direction={{ lg: 'row', xl: 'row', md: 'row', sm: 'row', xs: 'column' }}>
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        id="userId"
                        name="userId"
                        sx={{ minWidth: '250px' }}
                        label="User ID"
                        fullWidth
                        value={values.userId}
                        onChange={handleChange}
                      />
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="clubId"
                        name="clubId"
                        type="text"
                        label="IF Number"
                        value={values.clubId}
                        onChange={handleChange}
                      />
                    </Stack>
                    <Stack spacing={1} direction={{ lg: 'row', xl: 'row', md: 'row', sm: 'row', xs: 'column' }}>
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="phone"
                        name="phone"
                        sx={{ minWidth: '120px' }}
                        label="Phone"
                        value={values.phone}
                        onChange={handleChange}
                      />
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="email"
                        name="email"
                        type="email"
                        label="Email"
                        value={values.email}
                        onChange={handleChange}
                      />
                    </Stack>

                    <Stack spacing={1} direction={{ lg: 'row', xl: 'row', md: 'row', sm: 'row', xs: 'column' }}>
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        id="fullname"
                        name="fullname"
                        sx={{ minWidth: '290px' }}
                        label="Fullname"
                        value={values.fullname}
                        onChange={handleChange}
                      />

                      <TextField
                        select
                        id="paymentMethod"
                        name="paymentMethod"
                        fullWidth
                        label="Payment Method"
                        value={values.paymentMethod}
                        onChange={handleChange}
                      >
                        <MenuItem value="">NO FILTER</MenuItem>
                        <MenuItem value="ONLINE">ONLINE</MenuItem>
                        <MenuItem value="OFFLINE">OFFLINE</MenuItem>
                      </TextField>
                    </Stack>
                    <Stack direction={'row'} spacing={2} alignItems="center">
                      <TextField
                        type="date"
                        name="startDate"
                        label="Start Date"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={values.startDate}
                        onChange={handleChange}
                      />
                      <p style={{ paddingTop: '15px' }}>to</p>
                      <TextField
                        type="date"
                        name="endDate"
                        fullWidth
                        label="End Date"
                        InputLabelProps={{ shrink: true }}
                        value={values.endDate}
                        onChange={handleChange}
                      />
                    </Stack>
                    <Button variant="contained" type="submit" style={{ marginTop: '10px' }}>
                      Filter
                    </Button>
                  </Stack>
                </Form>
              )}
            </Formik>
          </Menu>
        </Box>
      </div>
    </>
  );
};

export default Filter;
